import './Statistics.css'
import { Table } from "reactstrap"
import { StatisticsEntry } from "./StatisticsEntry";
import { useTranslation } from 'react-i18next';
import { StatisticsProductTypeModel } from '../../backoffice/dtos/statistics/statisticsProductTypeModel';


export default function Statistics(
    {
        statisticsModel,
        measurementType
    }: {
        statisticsModel: StatisticsProductTypeModel;
        measurementType: string;
    }
) {
    const { t } = useTranslation(['statistics', 'promotion_timeline'])
    if (!statisticsModel)
        return <></>

    return (
        <>
            <Table>
                <thead>
                    <tr>
                        <th className="text-align-center">Top 5</th>
                    </tr>
                </thead>
            </Table>
            <Table striped hover>
                <thead>
                    <tr>
                        <th className="text-align-start">{t('brand')}</th>
                        <th className="text-align-end">{t(measurementType)}</th>
                        <th className="text-align-end">LY {t(measurementType)}</th>
                        <th className="text-align-end">{t(measurementType)} Diff</th>
                        <th className="text-align-end">{t(measurementType)} Diff %</th>
                        <th className="text-align-end">Euro</th>
                        <th className="text-align-end">LY Euro</th>
                        <th className="text-align-end">Euro Diff</th>
                        <th className="text-align-end">Euro Diff %</th>
                    </tr>
                </thead>
                <tbody>
                    {statisticsModel.topCustomersDetails.map(m =>
                        <StatisticsEntry columns={[
                            { type: 'Plain', value: m.company },
                            { type: 'Financial', value: (m.quantity), className: "text-align-end" },
                            { type: 'Financial', value: (m.lyQuantity), className: "text-align-end" },
                            { type: 'Delta', value: (m.quantityDelta), className: "text-align-end" },
                            { type: 'Delta %', value: (m.quantityDeltaPercent), className: "text-align-end" },
                            { type: 'Financial', value: (m.euro), className: "text-align-end" },
                            { type: 'Financial', value: (m.lyEuro), className: "text-align-end" },
                            { type: 'Delta', value: (m.euroDelta), className: "text-align-end" },
                            { type: 'Delta %', value: (m.euroDeltaPercent), className: "text-align-end" }
                        ]} />)}
                    <StatisticsEntry columns={[
                        { type: 'Plain', value: t('total'), className: "strong" },
                        { type: 'Financial', value: (statisticsModel.topCustomers.quantity), className: "text-align-end" },
                        { type: 'Financial', value: (statisticsModel.topCustomers.lyQuantity), className: "text-align-end" },
                        { type: 'Delta', value: (statisticsModel.topCustomers.quantityDelta), className: "text-align-end" },
                        { type: 'Delta %', value: (statisticsModel.topCustomers.quantityDeltaPercent), className: "text-align-end" },
                        { type: 'Financial', value: (statisticsModel.topCustomers.euro), className: "text-align-end" },
                        { type: 'Financial', value: (statisticsModel.topCustomers.lyEuro), className: "text-align-end" },
                        { type: 'Delta', value: (statisticsModel.topCustomers.euroDelta), className: "text-align-end" },
                        { type: 'Delta %', value: (statisticsModel.topCustomers.euroDeltaPercent), className: "text-align-end" }
                    ]} />
                </tbody>
            </Table>

            <br />
            <Table>
                <thead>
                    <tr>
                        <th className="text-align-center">Other</th>
                    </tr>
                </thead>
            </Table>
            <Table striped hover>
                <thead>
                    <tr>
                        <th className="text-align-start">{t('brand')}</th>
                        <th className="text-align-end">{t(measurementType)}</th>
                        <th className="text-align-end">LY {t(measurementType)}</th>
                        <th className="text-align-end">{t(measurementType)} Diff</th>
                        <th className="text-align-end">{t(measurementType)} Diff %</th>
                        <th className="text-align-end">Euro</th>
                        <th className="text-align-end">LY Euro</th>
                        <th className="text-align-end">Euro Diff</th>
                        <th className="text-align-end">Euro Diff %</th>
                    </tr>
                </thead>
                <tbody>
                    {statisticsModel.otherCustomersDetails.map(m =>
                        <StatisticsEntry columns={[
                            { type: 'Plain', value: m.company },
                            { type: 'Financial', value: (m.quantity), className: "text-align-end" },
                            { type: 'Financial', value: (m.lyQuantity), className: "text-align-end" },
                            { type: 'Delta', value: (m.quantityDelta), className: "text-align-end" },
                            { type: 'Delta %', value: (m.quantityDeltaPercent), className: "text-align-end" },
                            { type: 'Financial', value: (m.euro), className: "text-align-end" },
                            { type: 'Financial', value: (m.lyEuro), className: "text-align-end" },
                            { type: 'Delta', value: (m.euroDelta), className: "text-align-end" },
                            { type: 'Delta %', value: (m.euroDeltaPercent), className: "text-align-end" }
                        ]} />)}
                    <StatisticsEntry columns={[
                        { type: 'Plain', value: t('total'), className: "strong" },
                        { type: 'Financial', value: (statisticsModel.otherCustomers.quantity), className: "text-align-end" },
                        { type: 'Financial', value: (statisticsModel.otherCustomers.lyQuantity), className: "text-align-end" },
                        { type: 'Delta', value: (statisticsModel.otherCustomers.quantityDelta), className: "text-align-end" },
                        { type: 'Delta %', value: (statisticsModel.otherCustomers.quantityDeltaPercent), className: "text-align-end" },
                        { type: 'Financial', value: (statisticsModel.otherCustomers.euro), className: "text-align-end" },
                        { type: 'Financial', value: (statisticsModel.otherCustomers.lyEuro), className: "text-align-end" },
                        { type: 'Delta', value: (statisticsModel.otherCustomers.euroDelta), className: "text-align-end" },
                        { type: 'Delta %', value: (statisticsModel.otherCustomers.euroDeltaPercent), className: "text-align-end" }
                    ]} />
                </tbody>
            </Table>
            <br />
            <Table>
                <thead>
                    <tr>
                        <th className="text-align-center">Totals</th>
                    </tr>
                </thead>
            </Table>
            <Table striped hover>
                <thead>
                    <tr>
                        <th className="text-align-start">{t('brand')}</th>
                        <th className="text-align-end">{t(measurementType)}</th>
                        <th className="text-align-end">LY {t(measurementType)}</th>
                        <th className="text-align-end">{t(measurementType)} Diff</th>
                        <th className="text-align-end">{t(measurementType)} Diff %</th>
                        <th className="text-align-end">Euro</th>
                        <th className="text-align-end">LY Euro</th>
                        <th className="text-align-end">Euro Diff</th>
                        <th className="text-align-end">Euro Diff %</th>
                    </tr>
                </thead>
                <tbody>
                    <StatisticsEntry columns={[
                        { type: 'Plain', value: `TOP 5 ${t('total')}`, className: "strong" },
                        { type: 'Financial', value: (statisticsModel.topCustomers.quantity), className: "text-align-end" },
                        { type: 'Financial', value: (statisticsModel.topCustomers.lyQuantity), className: "text-align-end" },
                        { type: 'Delta', value: (statisticsModel.topCustomers.quantityDelta), className: "text-align-end" },
                        { type: 'Delta %', value: (statisticsModel.topCustomers.quantityDeltaPercent), className: "text-align-end" },
                        { type: 'Financial', value: (statisticsModel.topCustomers.euro), className: "text-align-end" },
                        { type: 'Financial', value: (statisticsModel.topCustomers.lyEuro), className: "text-align-end" },
                        { type: 'Delta', value: (statisticsModel.topCustomers.euroDelta), className: "text-align-end" },
                        { type: 'Delta %', value: (statisticsModel.topCustomers.euroDeltaPercent), className: "text-align-end" }
                    ]} />
                    <StatisticsEntry columns={[
                        { type: 'Plain', value: `Other ${t('total')}`, className: "strong" },
                        { type: 'Financial', value: (statisticsModel.otherCustomers.quantity), className: "text-align-end" },
                        { type: 'Financial', value: (statisticsModel.otherCustomers.lyQuantity), className: "text-align-end" },
                        { type: 'Delta', value: (statisticsModel.otherCustomers.quantityDelta), className: "text-align-end" },
                        { type: 'Delta %', value: (statisticsModel.otherCustomers.quantityDeltaPercent), className: "text-align-end" },
                        { type: 'Financial', value: (statisticsModel.otherCustomers.euro), className: "text-align-end" },
                        { type: 'Financial', value: (statisticsModel.otherCustomers.lyEuro), className: "text-align-end" },
                        { type: 'Delta', value: (statisticsModel.otherCustomers.euroDelta), className: "text-align-end" },
                        { type: 'Delta %', value: (statisticsModel.otherCustomers.euroDeltaPercent), className: "text-align-end" }
                    ]} />
                    <StatisticsEntry columns={[
                        { type: 'Plain', value: t('total'), className: "strong" },
                        { type: 'Financial', value: (statisticsModel.allCustomers.quantity), className: "text-align-end" },
                        { type: 'Financial', value: (statisticsModel.allCustomers.lyQuantity), className: "text-align-end" },
                        { type: 'Delta', value: (statisticsModel.allCustomers.quantityDelta), className: "text-align-end" },
                        { type: 'Delta %', value: (statisticsModel.allCustomers.quantityDeltaPercent), className: "text-align-end" },
                        { type: 'Financial', value: (statisticsModel.allCustomers.euro), className: "text-align-end" },
                        { type: 'Financial', value: (statisticsModel.allCustomers.lyEuro), className: "text-align-end" },
                        { type: 'Delta', value: (statisticsModel.allCustomers.euroDelta), className: "text-align-end" },
                        { type: 'Delta %', value: (statisticsModel.allCustomers.euroDeltaPercent), className: "text-align-end" }
                    ]} />
                </tbody>
            </Table>
        </>
    )
}
